import OrderIcon from '@material-ui/icons/ConfirmationNumber';
import OrderList from "./OrderList";

const user = {
    list: OrderList,
    icon: OrderIcon,
}

export default user;
